export default "__VITE_ASSET__DQSE$YtL__"